var _a;
import { __decorate, __metadata, __param } from "tslib";
import { I18nService } from '@/services/i18n-service';
import { inject, injectable } from 'inversify';
let DefaultPermissionActionContribution = class DefaultPermissionActionContribution {
    constructor(_i18nService) {
        this._i18nService = _i18nService;
    }
    registerCustomFieldActions(action) {
        action.registerCustomFieldAction({
            commandId: 'custom-field.default-permission-setting',
            icon: 'SolidSettings',
            label: this._i18nService.t('customField.actions.defaultPermissionSetting'),
            order: 3, // 调整为3，放在高级权限设置之前
            isEnabled: (context) => {
                // 只有企业管理员可以设置默认权限
                return context.isAdmin && this._isEnterpriseField(context);
            },
            isVisible: (context) => {
                // 对企业自定义字段显示，不需要选择字段
                return context.isAdmin && this._isEnterpriseField(context);
            },
        });
    }
    _isEnterpriseField(context) {
        // 判断是否为企业字段，根据isPublicMode判断
        // isPublicMode为true表示当前在企业字段模式
        return context.isPublicMode;
    }
};
DefaultPermissionActionContribution = __decorate([
    injectable(),
    __param(0, inject(I18nService)),
    __metadata("design:paramtypes", [typeof (_a = typeof I18nService !== "undefined" && I18nService) === "function" ? _a : Object])
], DefaultPermissionActionContribution);
export { DefaultPermissionActionContribution };
